import React, { Component } from 'react';
import SelectionBox from './Components/SelectionBox';
import ScoreBox from './Components/ScoreBox2';
import Config from './Configs/criteria.json';
import './CriteriaTableBasic.css';
import Tooltip from 'react-tooltip-lite';
import './Tooltip.css'

export default class CriteriaTableBasic extends Component {
    constructor(props) {
        super(props);
        // this.handleSelectionBoxChange = this.handleSelectionBoxChange.bind(this);
        // this.handleSelectAllSector = this.handleSelectAllSector.bind(this);
        // this.handleScoreBoxChange = this.handleScoreBoxChange.bind(this);
        this.state = {
            sectorextended: false,
            sectorextendedtext:"すべての業種を表示する"
        }
    }
    handleSelectionBoxChange = (name, value, ischecked) => {
        this.props.handleSelectionBoxChange(name, value, ischecked);
    }
    handleSelectAllMarket = () => {
        this.props.handleSelectAllMarket();
    }
    toggleExtendSector = () => {
        this.setState({ sectorextended: !this.state.sectorextended,sectorextendedtext:!this.state.sectorextended?"閉じる":"すべての業種を表示する" });
    }
    handleSelectAllSector = () => {
        this.props.handleSelectAllSector();
    }
    handleScoreBoxChange = (index, disabled, value) => {
        this.props.handleScoreBoxChange(index, disabled, value);
    }
    handleInvestAmtChange = (e) => {
        let investamtfrom = this.props.criteria.investamt[0];
        let investamtto = this.props.criteria.investamt[1];
        if (e.target.name === "investamtfrom") {
            investamtfrom = parseInt(e.target.value);
            if (investamtfrom === "" || investamtfrom < 0) {
                investamtfrom = -1;
            }
        } else if (e.target.name === "investamtto") {
            investamtto = parseInt(e.target.value);
            if (investamtto === "" || investamtto < 0) {
                investamtto = -1;
            }
        }
        this.props.handleInvestAmtChange([investamtfrom, investamtto]);
    }
    handleKeyPress = (e) => {
        e = e || window.event;
        let charCode = (typeof e.which == "number") ? e.which : e.keyCode;

        // Allow non-printable keys
        if (!charCode || charCode === 8 /* Backspace */ ) {
            return true;
        }
        
        let typedChar = String.fromCharCode(charCode);
        
        // Allow numeric characters and minus sign (-)
        if (/\d/.test(typedChar) || typedChar === "-" || typedChar === ".") {
            return true;
        }
        
        // In all other cases, suppress the event
        e.preventDefault();
        return false;
    }
    isSelectAllMarketChecked = () => {
        return this.props.isSelectAllMarketChecked();
    }
    isSelectAllSectorChecked = () => {
        return this.props.isSelectAllSectorChecked();
    }
    render() {
        return (
            <table className="CriteriaTable">
                <tbody>
                    <tr className="market">
                        <td className="titleTop">市場 <Tooltip className="info" direction="right-start" content={<div>選択した市場に上場している銘柄を表示します。<br/>東証ETFは、ETNを含みます。<br/>地方市場は、名証、福証、札証を含みます。<br/>その他は、インフラファンド、外国株、優先出資証券、上場前銘柄を含みます。</div>} arrow={false}>?</Tooltip></td>
                        <td className="content contenttop">
                        {
                            Config.criteria.market.map((market, idx) => (
                                <SelectionBox key={market.id} label={market.name} name="market" value={idx} onChange={this.handleSelectionBoxChange} ischecked={this.props.criteria.market[idx]} count={this.props.data?this.props.data[market.resultid]:0}/>
                            ))
                        }
                        <div style={{clear: "both"}} />
                        <SelectionBox key="selectall" type="selectall" label="すべて選択する" name="selectall" value="" onChange={this.handleSelectAllMarket} ischecked={this.isSelectAllMarketChecked()} />
                        </td>
                    </tr>
                    <tr>
                    <td className="title">規模 <Tooltip className="info" direction="right-start" content={<div>大型株：時価総額上位100位<br/>中型株：時価総額101位から500位<br/>小型株：時価総額501位以下</div>} arrow={false}>?</Tooltip></td>
                        <td className="content">
                        {
                            Config.criteria.capsize.map((capsize, idx) => (
                                <SelectionBox key={capsize.id} label={capsize.name} name="capsize" value={idx} onChange={this.handleSelectionBoxChange} ischecked={this.props.criteria.capsize[idx]} count={this.props.data?this.props.data[capsize.resultid]:0}/>
                            ))
                        }
                        </td>
                    </tr>
                    <tr>
                        <td className="title">採用指数 <Tooltip className="info" direction="right-start" content="選択した指数に採用されている銘柄を表示します。" arrow={false}>?</Tooltip></td>
                        <td className="content">
                        {
                            Config.criteria.index.map((index, idx) => (
                                <SelectionBox key={index.id} label={index.name} name="index" value={idx} onChange={this.handleSelectionBoxChange} ischecked={this.props.criteria.index[idx]} />
                            ))
                        }
                        </td>
                    </tr>
                    <tr className="sector">
                        <td className="titleTop">業種 <Tooltip className="info" direction="right-start" content="選択した業種に分類されている銘柄を表示します。" arrow={false}>?</Tooltip></td>
                        <td className="content contenttop">
                            <div className={ "container" + (this.state.sectorextended?" extended":"") }>
                        {
                            Config.criteria.sector.map((sector, idx) => (
                                <SelectionBox key={sector.id} label={sector.name} name="sector" value={idx} onChange={this.handleSelectionBoxChange} ischecked={this.props.criteria.sector[idx]} count={this.props.data?this.props.data["cs"+sector.id]:0}/>
                            ))
                        }
                            </div>
                            <div className={ "toggleextend" + (this.state.sectorextended?" is-open":"") } onClick={this.toggleExtendSector}>{this.state.sectorextendedtext}</div>
                            <SelectionBox key="selectall" type="selectall" label="すべて選択する" name="selectall" value="" onChange={this.handleSelectAllSector} ischecked={this.isSelectAllSectorChecked()} />
                        </td>
                    </tr>
                    <tr>
                        <td className="title">NISA <Tooltip className="info" direction="right-start" content="NISA（成長投資枠）で取引できる銘柄を検索できます。" arrow={false}>?</Tooltip></td>
                        <td className="content">
                        {
                            Config.criteria.nisa.map((nisa, idx) => (
                                <SelectionBox key={nisa.id} label={nisa.name} name="nisa" value={idx} onChange={this.handleSelectionBoxChange} ischecked={this.props.criteria.nisa[idx]} />
                            ))
                        }
                        </td>
                    </tr>
                    <tr>
                        <td className="title">レバレッジ/インバース <Tooltip className="info" direction="right-start" content="レバレッジ型（ブル型）/インバース型（ベア型）の銘柄を検索できます。" arrow={false}>?</Tooltip></td>
                        <td className="content">
                        {
                            Config.criteria.bullbear.map((bullbear, idx) => (
                                <SelectionBox key={bullbear.id} label={bullbear.name} name="bullbear" value={idx} onChange={this.handleSelectionBoxChange} ischecked={this.props.criteria.bullbear[idx]} />
                            ))
                        }
                        </td>
                    </tr>
                    <tr className="score">
                        <td className="titleTop">企業スコア <Tooltip className="info" direction="right-start" content="企業スコアは、株価や財務、収益予想データ等を使用して、リフィニティブ社が定義した定量分析により算出した数値です。各10段階評価で10が最高の評価を表します。" arrow={false}>?</Tooltip></td>
                        <td className="content contenttop">
                            <div className="container">
                            {
                                Config.criteria.score.map((score, idx) => (
                                    <ScoreBox key={score.id} label={score.name} name="score" index={idx} data={this.props.criteria.score[idx]} tooltip={score.tooltip} onScoreBoxChange={this.handleScoreBoxChange} />
                                ))
                            }
                                <div style={{clear: "both"}} />
                            </div>
                        </td>
                    </tr>
                    <tr className="investamt">
                        <td className="title">投資金額 <Tooltip className="info" direction="right-start" content="株価(終値)に売買単位株数をかけて算出された値です。" arrow={false}>?</Tooltip></td>
                        <td className="content">
                            <input maxlength='6' type="text" value={(this.props.criteria.investamt[0]===-1||!this.props.criteria.investamt[0])?"":this.props.criteria.investamt[0]} name="investamtfrom" onChange={this.handleInvestAmtChange} onKeyPress={this.handleKeyPress}></input>
                            &nbsp;万円以上&nbsp;
                            <input maxlength='6' type="text" value={(this.props.criteria.investamt[1]===-1||!this.props.criteria.investamt[1])?"":this.props.criteria.investamt[1]} name="investamtto" onChange={this.handleInvestAmtChange} onKeyPress={this.handleKeyPress}></input>
                            &nbsp;万円以下
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}